import { BrandRepository } from '../../domain/repositories/brand.repository';
import { BrandEntity } from '../../domain/entities/brand.entity';

export class ToggleBrandStatusUseCase {
  constructor(private readonly brandRepository: BrandRepository) {}

  async execute(id: string, status: boolean): Promise<BrandEntity> {
    if (this.brandRepository.toggleBrandStatus) {
      return this.brandRepository.toggleBrandStatus(id, status);
    }
    return this.brandRepository.updateBrand(id, { status } as any);
  }
}
